import React, { FC } from 'react';
import Skeleton from 'react-loading-skeleton';

import './Tabs.scss';

export interface TabInfo {
  label: string;
  value: string;
}

interface Props {
  tabs: TabInfo[];
  value: string;
  isLoading?: boolean;
  onChange: (tab: TabInfo) => void;
}

const Tabs: FC<Props> = ({ tabs, value, isLoading = false, onChange }) => {
  return (
    <div className='tabs'>
      {!isLoading && (
        <nav>
          {(tabs || []).map(tab => (
            <button key={`tab-${tab.value}`} className={value === tab.value ? 'active-tab' : ''} onClick={() => onChange(tab)}>
              {tab.label}
            </button>
          ))}
        </nav>
      )}
      {isLoading && (
        <div className='loaders'>
          <Skeleton height={30} width={150} />
          <Skeleton height={30} width={150} />
        </div>
      )}
    </div>
  );
};

export default Tabs;
